import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd'

import Navbar from '../components/Navbar';
import Footer from '../components/Footer'

import articles from '../data/articles.json'

import './article.css'

const Article = () => {
  const { addressId } = useParams();
  const [myPost, setMyPost] = useState([]);
  const [isLoaded, setLoaded] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);

  // getData performs api call with fetch function
  const getPost = useCallback(async () => {
    // FIXME: Removed 040123 to contain articles internally
    // const response = await fetch(`https://articlesapi.wordpay.dev/api/v1/articles/${addressId}`)
    // const post = await response.json()
    const article = articles.payload.find(article => addressId === article._id)
    
    setMyPost(article)
    setLoaded(true)
  }, [addressId])

  // API call in useEffect
  useEffect(() => {
    getPost()

  }, [getPost])

  useEffect(() => {
    if (!isLoaded) {
      return
    }
    
    const script = document.createElement('script');
    script.src = 'https://ad-widget.wordpay.dev/ad/latest/ad-widget.js';
    script.id = 'wordpay-ad-script';
    script.async = true;
    script.onload = () => {
      setScriptLoaded(true);
    }
    document.body.appendChild(script);
  }, [isLoaded])

  useEffect(() => {
    if (!(isLoaded && isScriptLoaded)) {
      return
    }

    window.wordpay_ads?.reload && window.wordpay_ads.reload();

  }, [isLoaded, isScriptLoaded])

  return (
    <section className={`wordpay-article-wrapper ${isLoaded ? '' : 'wordpay-article-wrapper--loading'}`}>
      <Navbar cssClass='wordpay-article-header' />
      <article className={`wordpay-article ${isLoaded ? '' : 'wordpay-article--loading'}`}>
        {isLoaded ?
          <header className='wordpay-article__header'>
            <h1 className='wordpay-article__title'>{myPost.title}</h1>
            {myPost.imageSource && myPost.imageSource.indexOf('data:image') === -1 &&
              <img className='wordpay-article__image' src={myPost.imageSource} alt={myPost.title} />
            }
            <address>{myPost.byLine}</address>
          </header>
        : <Spin size='large' className='wordpay-article__loader' />}

        <div className='wordpay-ad-original-content'>
          <div id="wordpay-ad" className="wordpay-ad-video"></div>
          {isLoaded &&
            <main className='wordpay-article__content'>
              {myPost.main}
            </main>
          }
        </div>
      </article>
      <Footer />
    </section>
  )
}

/*  */
//   <Card key={myPost._id}   subtitle={myPost.main} author={} isSingleArticle={false} cssClass="wordpay-demo__main-content-all-card" titleSectionClass='wordpay-demo__card-article-title-section' titleClass='wordpay-demo__card-article-title'
//     subtitleClass='wordpay-demo__card-article-subtitle' imageClass='wordpay-demo__card-article-image' authorClass='wordpay-demo__card-article-author' />
// </>

export default Article;